import * as ngCore from '@angular/core'

import * as confirmationDialog from './confirmation-dialog'
import * as modal from './modal'
import * as slideout from './slideout'
import * as variablesSlideout from './variables-slideout'

/** Hosts all Mosaic page-level overlays such as confirmation, modal, and slideout surfaces. */
@ngCore.Component({
  imports: [
    confirmationDialog.Component,
    modal.Component,
    slideout.Component,
    variablesSlideout.Component,
  ],
  selector: 'atn-mosaic-page-overlays',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {}
